import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Table, Badge, Button, Form, Dropdown } from 'react-bootstrap';
import './TestExecution.css';

const TestExecution = () => {
  const [showFilters, setShowFilters] = useState(false);

  const executions = [
    {
      id: 'EXE-0012',
      testCase: { id: 'TC-0145', title: 'User Login with Valid Credentials' },
      tester: { name: 'Sarah Johnson', avatar: 'SJ' },
      executedDate: '2024-03-15 14:30',
      result: 'Pass',
      duration: '5m 30s',
      environment: 'UAT',
      build: 'v2.3.1',
      bugs: 0
    },
    {
      id: 'EXE-0011',
      testCase: { id: 'TC-0156', title: 'Payment Gateway Integration' },
      tester: { name: 'Mike Chen', avatar: 'MC' },
      executedDate: '2024-03-15 13:45',
      result: 'Fail',
      duration: '8m 15s',
      environment: 'QA',
      build: 'v2.3.1',
      bugs: 2
    },
    {
      id: 'EXE-0010',
      testCase: { id: 'TC-0178', title: 'Email Notification System' },
      tester: { name: 'Emily Davis', avatar: 'ED' },
      executedDate: '2024-03-15 12:20',
      result: 'Blocked',
      duration: '2m 10s',
      environment: 'UAT',
      build: 'v2.3.0',
      bugs: 1
    },
    {
      id: 'EXE-0009',
      testCase: { id: 'TC-0189', title: 'User Registration Flow' },
      tester: { name: 'Sarah Johnson', avatar: 'SJ' },
      executedDate: '2024-03-15 11:15',
      result: 'Pass',
      duration: '4m 45s',
      environment: 'QA',
      build: 'v2.3.1',
      bugs: 0
    },
    {
      id: 'EXE-0008',
      testCase: { id: 'TC-0201', title: 'Data Export Functionality' },
      tester: { name: 'Mike Chen', avatar: 'MC' },
      executedDate: '2024-03-15 10:30',
      result: 'Pass',
      duration: '6m 20s',
      environment: 'UAT',
      build: 'v2.3.1',
      bugs: 0
    }
  ];

  const stats = [
    { label: 'Total Executions', value: 156, icon: 'play-circle', color: 'primary' },
    { label: 'Passed', value: 98, icon: 'check-circle', color: 'success' },
    { label: 'Failed', value: 42, icon: 'times-circle', color: 'danger' },
    { label: 'Blocked', value: 16, icon: 'ban', color: 'warning' }
  ];

  const getResultBadge = (result) => {
    const variants = {
      'Pass': 'success',
      'Fail': 'danger',
      'Blocked': 'warning',
      'Skipped': 'secondary'
    };
    return <Badge bg={variants[result] || 'secondary'}>{result}</Badge>;
  };

  return (
    <div className="test-execution-page">
      <Row className="mb-4 gy-3">
        {stats.map((stat, index) => (
          <Col lg={3} md={6} key={index}>
            <Card className="c-card-1 h-100">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="text-muted small mb-1">{stat.label}</div>
                    <h3 className="mb-0 fw-bold">{stat.value}</h3>
                  </div>
                  <div className={`stat-icon text-${stat.color}`}>
                    <i className={`fas fa-${stat.icon}`}></i>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {showFilters && (
        <Card className="c-card-1 mb-4">
          <Card.Body className="c-card-body-1">
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Result</Form.Label>
                  <Form.Select size="sm">
                    <option value="">All Results</option>
                    <option value="pass">Pass</option>
                    <option value="fail">Fail</option>
                    <option value="blocked">Blocked</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Tester</Form.Label>
                  <Form.Select size="sm">
                    <option value="">All Testers</option>
                    <option value="sarah">Sarah Johnson</option>
                    <option value="mike">Mike Chen</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Environment</Form.Label>
                  <Form.Select size="sm">
                    <option value="">All Environments</option>
                    <option value="qa">QA</option>
                    <option value="uat">UAT</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Build</Form.Label>
                  <Form.Select size="sm">
                    <option value="">All Builds</option>
                    <option value="v2.3.1">v2.3.1</option>
                    <option value="v2.3.0">v2.3.0</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex gap-2 mt-3">
              <Button variant="primary" size="sm">
                <i className="fas fa-search me-2"></i>
                Apply Filters
              </Button>
              <Button variant="outline-secondary" size="sm">
                <i className="fas fa-times me-2"></i>
                Clear
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      <Card className="c-card-1">
        <Card.Header className="c-card-header-1">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Recent Executions</h5>
            <Button variant="outline-primary" size="sm">
              <i className="fas fa-file-export me-2"></i>
              Export
            </Button>
          </div>
        </Card.Header>
        <Card.Body className="c-card-body-1 p-0">
          <Table responsive hover className="mb-0">
            <thead className="bg-light">
              <tr>
                <th className="px-3 py-3 border-0">Execution ID</th>
                <th className="px-3 py-3 border-0">Test Case</th>
                <th className="px-3 py-3 border-0">Tester</th>
                <th className="px-3 py-3 border-0">Executed Date</th>
                <th className="px-3 py-3 border-0">Result</th>
                <th className="px-3 py-3 border-0">Duration</th>
                <th className="px-3 py-3 border-0">Environment</th>
                <th className="px-3 py-3 border-0">Build</th>
                <th className="px-3 py-3 border-0">Bugs</th>
                <th className="px-3 py-3 border-0 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {executions.map((execution) => (
                <tr key={execution.id}>
                  <td className="px-3 py-3">
                    <Link to={`/qc/test-execution/${execution.id}`} className="text-primary fw-medium">
                      {execution.id}
                    </Link>
                  </td>
                  <td className="px-3 py-3">
                    <Link to={`/qc/test-cases/${execution.testCase.id}`} className="text-decoration-none">
                      <div className="fw-medium">{execution.testCase.id}</div>
                      <div className="text-muted small">{execution.testCase.title}</div>
                    </Link>
                  </td>
                  <td className="px-3 py-3">
                    <div className="d-flex align-items-center gap-2">
                      <div className="avatar-circle">
                        {execution.tester.avatar}
                      </div>
                      <span>{execution.tester.name}</span>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <div className="text-muted small">{execution.executedDate}</div>
                  </td>
                  <td className="px-3 py-3">
                    {getResultBadge(execution.result)}
                  </td>
                  <td className="px-3 py-3">
                    <span className="text-muted">{execution.duration}</span>
                  </td>
                  <td className="px-3 py-3">
                    <Badge bg="info" className="badge-soft">{execution.environment}</Badge>
                  </td>
                  <td className="px-3 py-3">
                    <Badge bg="secondary" className="badge-soft">{execution.build}</Badge>
                  </td>
                  <td className="px-3 py-3">
                    {execution.bugs > 0 ? (
                      <Badge bg="danger">{execution.bugs} bug{execution.bugs > 1 ? 's' : ''}</Badge>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td className="px-3 py-3 text-end">
                    <Dropdown align="end">
                      <Dropdown.Toggle variant="link" className="text-muted p-0">
                        <i className="fas fa-ellipsis-v"></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>
                          <i className="fas fa-eye me-2"></i>
                          View Details
                        </Dropdown.Item>
                        <Dropdown.Item>
                          <i className="fas fa-redo me-2"></i>
                          Re-execute
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item className="text-danger">
                          <i className="fas fa-trash me-2"></i>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TestExecution;
